import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, renderList as _renderList, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/home-selected-logo.png'
import _imports_1 from '@/assets/image/home-selected-banner-icon.png'


const _withScopeId = n => (_pushScopeId("data-v-3a794ea8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "plat-channel",
  class: "PlatChannel"
}
const _hoisted_2 = { class: "viewport guideDom-pure-all-4 flex-bwn" }
const _hoisted_3 = { class: "plat-title flex-ter" }
const _hoisted_4 = { class: "text2" }
const _hoisted_5 = { class: "title_brand" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "banner_logo",
  src: _imports_0,
  alt: "",
  srcset: ""
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "banner_icon",
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_8 = { class: "title" }
const _hoisted_9 = {
  class: "flex tab-name",
  style: {"padding-left":"20px"}
}
const _hoisted_10 = ["onMouseenter"]
const _hoisted_11 = { class: "bottom-bar" }
const _hoisted_12 = { class: "brand-title rel" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/icon/brand/brand_index_new.png",
  alt: ""
}, null, -1))
const _hoisted_14 = { class: "brand-desc" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/icon/brand/brand_index_halfarraw.png",
  alt: ""
}, null, -1))
const _hoisted_16 = ["src"]
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "brand-scroll rel" }
const _hoisted_19 = { class: "brand-scroll-content" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = ["src"]
const _hoisted_22 = { class: "card-logo-box" }
const _hoisted_23 = ["src"]
const _hoisted_24 = { class: "card-name" }
const _hoisted_25 = { class: "brand-scroll-content" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = ["src"]
const _hoisted_28 = { class: "card-logo-box" }
const _hoisted_29 = ["src"]
const _hoisted_30 = { class: "card-name" }
const _hoisted_31 = { class: "brand-scroll-content" }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = ["src"]
const _hoisted_34 = { class: "card-logo-box" }
const _hoisted_35 = ["src"]
const _hoisted_36 = { class: "card-name" }

import { onMounted, reactive, computed, ref, watch } from 'vue'
import { getPurePlatformList } from '@/apis/platform'
import { brandBanner } from '@/apis/brand'
import PlatIcons from './PlatIcons.vue'
import { t } from '@/plugins/i18n'
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
import { isJA, useRtfix, useSite2Station, useSite, isKO } from '@/store'
import { throttle } from 'lodash'
import bus from '@/util/useBus'
import { TaEvent, taTrack } from '@/util/buryingPoint'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

_useCssVars(_ctx => ({
  "d7c92d46": (_unref(defaultTranslateX))
}))

const arrowLeft = require('@/assets/image/icon/aw-lf.png')
const arrowRight = require('@/assets/image/icon/aw-rt.png')

const store = useStore()
const router = useRouter()

onMounted(() => {
  getList()
})

const route = useRoute()
const buss = reactive(store.state.bussiness)
const langType = computed(() => store.state.bussiness.langType)
const jumpToSearch = () => {
  store.commit('bussiness/platformType', 'AM')
  const keyword = route.query.keyword || (langType.value === 2 ? '1688严选' : t('1688严选'))
  buss.keyword = keyword
  const query: any = {
    schannel: 2,
    platformType: 'AM',
    keyword: keyword
  }
  router[route.name?.toString().includes('list') ? 'replace' : 'push'](
    useRtfix('list', { query })
  )
}

const stationCode = useSite2Station()
const data: any = reactive({
  // 列表
  list: [],
  curKey: ''
})

onMounted(() => {
  getList()
  getBrand()
})

// 获取列表
const getList = () => {
  getPurePlatformList({ stationCode }).then((res: any) => {
    if (res.code === '0') {
      const all = {
        key: '-1',
        type: t('全部'),
        onlineManageList: []
      }

      res.data.forEach((item: any) => {
        if (Array.isArray(item.onlineManageList)) {
          all.onlineManageList = all.onlineManageList.concat(item.onlineManageList)
        }
      })

      const list = [all, ...res.data]

      list.forEach((item, index) => {
        if (Array.isArray(item.onlineManageList)) {
          item.onlineManageList.forEach((i: any, idx: number) => {
            if (i.platformName.includes('1688')) {
              item.onlineManageList.unshift(item.onlineManageList.splice(idx, 1)[0])
            }
          })
        }
      })

      data.list = list
      data.curKey = data.list[0].key
    }
  })
}

// 获取品牌集
const brandsList = ref([] as any)
const getBrand = () => {
  brandBanner().then(res => {
    if (res.data.length < 2) {
      return
    }
    brandsList.value = res.data.splice(0, 9)
    //   let str = `
    //     @keyframes brandBannerAnimation {
    //   `
    //   const num = brandsList.value.length
    //   let transNum = 0
    //   for (let i = 0; i < 100; i += (100 / num)) {
    //     console.log(i)
    //     if (i !== 0) {
    //       str += `${Math.floor(i) - 2}% {transform: translateX(-${transNum}px)}`
    //       transNum += 260
    //     }
    //     str += `${Math.floor(i)}% {transform: translateX(-${transNum}px)}`
    //   }
    //   str += `98% {transform: translateX(-${transNum}px)}100% {transform: translateX(-${transNum + 260}px)}}`
    //   addcss(str)
    //   function addcss (css:any) {
    //     var head = document.getElementsByTagName('head')[0]
    //     var s = document.createElement('style')
    //     s.setAttribute('type', 'text/css')
    //     if (s.styleSheet) { // IE
    //       s.styleSheet.cssText = css
    //     } else { // the world
    //       s.appendChild(document.createTextNode(css))
    //     }
    //     head.appendChild(s)
    //   }
  })
}
const transIndex = ref(0)
const brandOnFocus = ref(false)
const brandSwitch = setInterval(() => {
  if (brandOnFocus.value) {
    return
  }
  changeIndex(1)
}, 5000)
const defaultTranslateX = computed(() => {
  return `rotateX(${-brandsList.value.length * 260}px)`
})
const brandTransition = ref(300)
const resetBrandScroll = (target: number) => {
  brandTransition.value = 0
  setTimeout(() => {
    transIndex.value = target
    setTimeout(() => {
      brandTransition.value = 300
    }, 100)
  }, 100)
}
const changeIndex = throttle((num: number) => {
  transIndex.value += num
}, 1000)
watch(() => transIndex.value, () => {
  // 切到第二轮第一张重置
  if (transIndex.value === brandsList.value.length) {
    setTimeout(() => {
      resetBrandScroll(0)
    }, 300)
  }
  // 切到前面去了 重置到第一轮最后1长
  if (transIndex.value === -1) {
    setTimeout(() => {
      resetBrandScroll(brandsList.value.length - 1)
    }, 300)
  }
})

const navigateToBrandList = () => {
  router.push(useRtfix('BrandList'))
}

const toBrandDetail = (id: string) => {
  router.push(useRtfix('BrandDetail', { params: { brand: id } }))
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        style: {"flex-grow":"1"},
        onClick: _cache[0] || (_cache[0] = () => {
        _unref(taTrack)({
          event: _unref(TaEvent).BTN_CLICK,
          value: {
            position: 'online_shopping_mall'
          }
        })
      })
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", {
            class: _normalizeClass(["text1", _unref(useSite)()])
          }, _toDisplayString(_unref(t)('人气购物网站')), 3),
          _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(t)('发现海量中国商品，助您更简单，更透明地下单购物！')), 1)
        ]),
        (!_unref(isJA)())
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (brandsList.value.length)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    onClick: jumpToSearch,
                    class: _normalizeClass(["selected_banner selected_banner_brand", { ko: _unref(isKO)() }])
                  }, [
                    _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(t)('查看1688官方精选供应商商品')), 1)
                  ], 2))
                : (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    onClick: jumpToSearch,
                    class: "selected_banner"
                  }, [
                    _hoisted_6,
                    _hoisted_7,
                    _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(t)('查看1688官方精选供应商商品')), 1)
                  ]))
            ], 64))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_9, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).list, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["tab btn flex-col flex-ter", { active: item.key === _unref(data).curKey }]),
              key: item.key,
              onMouseenter: ($event: any) => (_unref(data).curKey = item.key)
            }, [
              _createElementVNode("span", null, _toDisplayString(item.type), 1),
              _createVNode(_Transition, {
                "enter-active-class": "animated zoomIn",
                "leave-active-class": "animated zoomOut"
              }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("span", _hoisted_11, null, 512), [
                    [_vShow, item.key === _unref(data).curKey]
                  ])
                ]),
                _: 2
              }, 1024)
            ], 42, _hoisted_10))
          }), 128))
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).list, (item) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: item.key
          }, [
            (item.key === _unref(data).curKey)
              ? (_openBlock(), _createBlock(PlatIcons, {
                  key: 0,
                  list: item.onlineManageList,
                  wrapNum: brandsList.value.length ? 6 : 10,
                  style: _normalizeStyle(brandsList.value.length ? 'width:730px' : 'width:1200px')
                }, null, 8, ["list", "wrapNum", "style"]))
              : _createCommentVNode("", true)
          ], 64))
        }), 128))
      ]),
      (brandsList.value.length)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "brand",
            onClick: _cache[5] || (_cache[5] = () => {
        _unref(taTrack)({
          event: _unref(TaEvent).BTN_CLICK,
          value: {
            position: 'brand_ollection'
          }
        })
      })
          }, [
            _createElementVNode("div", _hoisted_12, [
              _createTextVNode(_toDisplayString(_unref(t)('品牌集')) + " ", 1),
              _hoisted_13
            ]),
            _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(t)('品牌集的优势介绍 给用户带来什么')), 1),
            _createElementVNode("div", {
              class: "brand-btn flex-cen-ter cursor-pt",
              onClick: navigateToBrandList
            }, [
              _createTextVNode(_toDisplayString(_unref(t)('查看全部')) + " ", 1),
              _hoisted_15
            ]),
            _createElementVNode("div", {
              onMouseenter: _cache[3] || (_cache[3] = ($event: any) => (brandOnFocus.value = true)),
              onMouseleave: _cache[4] || (_cache[4] = ($event: any) => (brandOnFocus.value = false))
            }, [
              (brandOnFocus.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", {
                      class: "brand-switch abs cursor-pt flex-cen-ter",
                      style: {"left":"10px"},
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(changeIndex)(-1)))
                    }, [
                      _createElementVNode("img", {
                        src: _unref(arrowLeft),
                        alt: ""
                      }, null, 8, _hoisted_16)
                    ]),
                    _createElementVNode("div", {
                      class: "brand-switch abs cursor-pt flex-cen-ter",
                      style: {"right":"10px"},
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(changeIndex)(+1)))
                    }, [
                      _createElementVNode("img", {
                        src: _unref(arrowRight),
                        alt: ""
                      }, null, 8, _hoisted_17)
                    ])
                  ], 64))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", {
                  class: "brand-scroll-animate flex",
                  style: _normalizeStyle({ transform: `translateX(${-((transIndex.value + brandsList.value.length) * 260)}px)`, 'transition-duration': `${brandTransition.value}ms` })
                }, [
                  _createElementVNode("div", _hoisted_19, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(brandsList.value, (i) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "brand-scroll-content-card cursor-pt",
                        key: i.brandId,
                        onClick: ($event: any) => (toBrandDetail(i.brandId))
                      }, [
                        _createElementVNode("img", {
                          src: i.displayedProductMainImg,
                          alt: "",
                          class: "card-main"
                        }, null, 8, _hoisted_21),
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("img", {
                            src: i.brandLogo,
                            alt: "",
                            class: "card-logo"
                          }, null, 8, _hoisted_23)
                        ]),
                        _createElementVNode("div", _hoisted_24, _toDisplayString(i.brandName), 1)
                      ], 8, _hoisted_20))
                    }), 128))
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(brandsList.value, (i) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "brand-scroll-content-card cursor-pt",
                        key: i.brandId,
                        onClick: ($event: any) => (toBrandDetail(i.brandId))
                      }, [
                        _createElementVNode("img", {
                          src: i.displayedProductMainImg,
                          alt: "",
                          class: "card-main"
                        }, null, 8, _hoisted_27),
                        _createElementVNode("div", _hoisted_28, [
                          _createElementVNode("img", {
                            src: i.brandLogo,
                            alt: "",
                            class: "card-logo"
                          }, null, 8, _hoisted_29)
                        ]),
                        _createElementVNode("div", _hoisted_30, _toDisplayString(i.brandName), 1)
                      ], 8, _hoisted_26))
                    }), 128))
                  ]),
                  _createElementVNode("div", _hoisted_31, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(brandsList.value, (i) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "brand-scroll-content-card cursor-pt",
                        key: i.brandId,
                        onClick: ($event: any) => (toBrandDetail(i.brandId))
                      }, [
                        _createElementVNode("img", {
                          src: i.displayedProductMainImg,
                          alt: "",
                          class: "card-main"
                        }, null, 8, _hoisted_33),
                        _createElementVNode("div", _hoisted_34, [
                          _createElementVNode("img", {
                            src: i.brandLogo,
                            alt: "",
                            class: "card-logo"
                          }, null, 8, _hoisted_35)
                        ]),
                        _createElementVNode("div", _hoisted_36, _toDisplayString(i.brandName), 1)
                      ], 8, _hoisted_32))
                    }), 128))
                  ])
                ], 4)
              ])
            ], 32)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})